module.exports = __webpack_public_path__ + "static/media/Flabébé_gaussian2.23f02a4b.png";